'use client';

import { Box } from '@mui/material';
import { BarChart, GaugeChart, LineChart, PieChart, ScatterChart } from 'echarts/charts';
import { DatasetComponent, GridComponent, LegendComponent, PolarComponent, ToolboxComponent, TooltipComponent, VisualMapComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import type { ECBasicOption } from 'echarts/types/dist/shared';
import { useCallback, useEffect, useRef } from 'react';
import type { ChartSchemaT } from '../../schema/chart.schema';
const componentMap = {
  CanvasRenderer: CanvasRenderer,
  SVGRenderer: SVGRenderer,
  GridComponent: GridComponent,
  TooltipComponent: TooltipComponent,
  ToolboxComponent: ToolboxComponent,
  PolarComponent: PolarComponent,
  DatasetComponent: DatasetComponent,
  VisualMapComponent: VisualMapComponent,
  LegendComponent: LegendComponent,
  LineChart: LineChart,
  GaugeChart: GaugeChart,
  BarChart: BarChart,
  PieChart: PieChart,
  ScatterChart: ScatterChart
};
export const Chart = (props: ChartSchemaT) => {
  const {
    option,
    useComponents
  } = props;
  const chartRef = useRef<HTMLDivElement | null>(null);
  const chartInstance = useRef<echarts.ECharts | null>(null);
  const configEchart = useCallback(() => {
    const toUse = useComponents.map(componentName => componentMap[componentName]);
    echarts.use(toUse);
  }, [useComponents]);
  useEffect(() => {
    if (chartRef.current && !chartInstance.current) {
      // Register necessary chart components
      configEchart();

      // Initialize the chart instance
      chartInstance.current = echarts.init(chartRef.current);
      chartInstance.current.setOption(option as echarts.EChartsCoreOption);
      // chartInstance.current.setOption(option);
    }
    return () => {
      if (chartInstance.current) {
        chartInstance.current.dispose();
      }
    };
  }, [configEchart]);
  return <Box component="div" height="250px" sx={{
    pointerEvents: 'none'
  }} data-sentry-element="Box" data-sentry-component="Chart" data-sentry-source-file="chart.tsx">
      <div ref={chartRef} style={{
      width: '250px',
      height: '250px'
    }} />
    </Box>;
};